import { render } from "./ArticleDetailView.vue?vue&type=template&id=2f7d7468"
import script from "./ArticleDetailView.vue?vue&type=script&lang=js"
export * from "./ArticleDetailView.vue?vue&type=script&lang=js"

import "./ArticleDetailView.vue?vue&type=style&index=0&id=2f7d7468&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__